import React from 'react';
import { Button, Descriptions, Modal, Space, Tag } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { ESTADO_COLORS, formatFecha, formatHora } from './agendaConstants';

const AgendaReunionDetalle = ({ reunion, open, onClose, onEdit, onDelete }) => {
  if (!reunion) return null;

  return (
    <Modal
      title="Detalle de reunión"
      open={open}
      onCancel={onClose}
      footer={
        <Space>
          <Button icon={<EditOutlined />} type="primary" onClick={() => onEdit(reunion)}>
            Editar
          </Button>
          <Button icon={<DeleteOutlined />} danger onClick={() => onDelete(reunion)}>
            Eliminar
          </Button>
          <Button onClick={onClose}>Cerrar</Button>
        </Space>
      }
      width={560}
      centered
    >
      <Descriptions column={1} size="small" bordered style={{ marginTop: 8 }}>
        <Descriptions.Item label="Fecha">{formatFecha(reunion.fecha)}</Descriptions.Item>
        <Descriptions.Item label="Horario">
          {formatHora(reunion.horaInicio)} — {formatHora(reunion.horaFin)}
        </Descriptions.Item>
        <Descriptions.Item label="Cliente">{reunion.cliente}</Descriptions.Item>
        <Descriptions.Item label="Contacto">{reunion.contacto || '—'}</Descriptions.Item>
        <Descriptions.Item label="Teléfono">{reunion.telefono || '—'}</Descriptions.Item>
        <Descriptions.Item label="Email">{reunion.email || '—'}</Descriptions.Item>
        <Descriptions.Item label="Localidad">{reunion.localidad || '—'}</Descriptions.Item>
        <Descriptions.Item label="Producto">{reunion.producto || '—'}</Descriptions.Item>
        <Descriptions.Item label="Estado">
          <Tag color={ESTADO_COLORS[reunion.estado] || 'default'}>{reunion.estado}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Comentarios">{reunion.comentarios || '—'}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default AgendaReunionDetalle;
